<template>
  <div class="d-none d-sm-flex justify-content-center pb-3" >
    <button
	@click="confirmObject"
      type="button"
      id="new-btn"
      class="rounded-pill p-1 ps-2 pe-3 btn btn-outline-secondary text-nowrap btn-sm"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 86 86"
        width="16"
        height="16"
      >
        <polygon
          points="86 34.76 51.24 34.76 51.24 0 34.76 0 34.76 34.76 0 34.76 0 51.24 34.76 51.24 34.76 86 51.24 86 51.24 51.24 86 51.24 86 34.76"
          fill="#004d97"
          stroke-width="0"
        ></polygon></svg>点击清除所有选项
    </button>
  </div>
</template>

<script>

	
	import { Dialog } from 'vant';
	
export default {
  name: "btn-new",
  data() {
    return {};
  },
  methods: {
    clearImages(){
      this.$emit("clearImages")
      
    },
    confirmObject() {
		
		
		Dialog.confirm({
		  
		  message: '您还未保存图片，是否确认清除全部标记',
		  confirmButtonText:"是",
		  cancelButtonText:"否",
		  confirmButtonColor:"#18468E"
		})
		  .then(() => {
		    // on confirm
			window.location.reload();
		  })
		  .catch(() => {
		    // on cancel
		  });
		  
		  
		  
      
      
      
    },
  },
};
</script>

<style scoped="scoped" lang="less">
svg{
  transform: rotate(45deg);
}
</style>
